var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4036 0.44873L16.5498 8.57588L18.5656 3.78105L27.4036 0.44873Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37305 0.44873L13.1281 8.65279L11.2111 3.78105L2.37305 0.44873Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5016 19.2891L20.6143 23.7546L26.7925 25.4695L28.5582 19.3877L23.5016 19.2891Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.22852 19.3877L2.98345 25.4695L9.16168 23.7546L6.28509 19.2891L1.22852 19.3877Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82322 11.7437L7.10156 14.373L13.2261 14.6481L13.019 7.99323L8.82322 11.7437Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9527 11.7435L16.6915 7.91614L16.5498 14.648L22.6744 14.3728L20.9527 11.7435Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16211 23.7544L12.8566 21.9388L9.6741 19.4319L9.16211 23.7544Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9199 21.9388L20.6144 23.7544L20.1024 19.4319L16.9199 21.9388Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6144 23.7545L16.9199 21.9388L17.214 24.3698L17.1818 25.3925L20.6144 23.7545Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16211 23.7545L12.5947 25.3925L12.5732 24.3698L12.8566 21.9388L9.16211 23.7545Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6599 17.8254L9.58691 16.9132L11.7551 15.9122L12.6599 17.8254Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1162 17.8254L18.021 15.9122L20.2 16.9132L17.1162 17.8254Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16175 23.7546L9.6952 19.2891L6.28516 19.3877L9.16175 23.7546Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0811 19.2891L20.6145 23.7546L23.5018 19.3877L20.0811 19.2891Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6744 14.3729L16.5498 14.6481L17.1165 17.8255L18.0214 15.9123L20.2003 16.9133L22.6744 14.3729Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58638 16.9133L11.7546 15.9123L12.6594 17.8255L13.2261 14.6481L7.10156 14.3729L9.58638 16.9133Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10156 14.3729L9.67332 19.4321L9.58638 16.9133L7.10156 14.3729Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2002 16.9133L20.1025 19.4321L22.6743 14.3729L20.2002 16.9133Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2269 14.6479L12.6602 17.8254L13.3793 21.5758L13.5317 16.638L13.2269 14.6479Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.55 14.6479L16.2559 16.6272L16.3975 21.5758L17.1167 17.8254L16.55 14.6479Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1166 17.8254L16.3975 21.5759L16.9202 21.9388L20.1027 19.432L20.2004 16.9133L17.1166 17.8254Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58691 16.9133L9.67386 19.432L12.8564 21.9388L13.3791 21.5759L12.6599 17.8254L9.58691 16.9133Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1822 25.3926L17.2144 24.37L16.9429 24.1284H12.8341L12.5732 24.37L12.5947 25.3926L9.16211 23.7546L10.361 24.7437L12.8019 26.4489H16.9751L19.4159 24.7437L20.6148 23.7546L17.1822 25.3926Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9203 21.9386L16.3976 21.5757H13.3793L12.8566 21.9386L12.5732 24.3696L12.8341 24.128H16.9429L17.2144 24.3696L16.9203 21.9386Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8606 9.10454L28.7762 4.61739L27.4034 0.44873L16.9199 8.30179L20.9525 11.7435L26.651 13.427L27.9046 11.9418L27.3594 11.5464L28.2309 10.7425L27.5665 10.215L28.4381 9.54437L27.8606 9.10454Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.61739L1.92631 9.10454L1.33811 9.54437L2.20967 10.215L1.54526 10.7425L2.41683 11.5464L1.87157 11.9418L3.12524 13.427L8.82368 11.7435L12.8563 8.30179L2.37282 0.44873L1 4.61739Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6511 13.4271L20.9526 11.7437L22.6743 14.3729L20.1025 19.432L23.5019 19.3876H28.5584L26.6511 13.4271Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82357 11.7437L3.12513 13.4271L1.22852 19.3876H6.28509L9.67367 19.432L7.10191 14.3729L8.82357 11.7437Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5498 14.648L16.9201 8.3018L18.5656 3.78107H11.2109L12.8564 8.3018L13.2267 14.648L13.3684 16.6489L13.3791 21.5759H16.3974L16.4081 16.6489L16.5498 14.648Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.109038,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/Metamask.3fc7aedbbfdb6c5710d8c4df564b6dc6.svg";
export { ForwardRef as ReactComponent };